/* eslint-disable @typescript-eslint/naming-convention */

import { DigitalSuiteGenericNavBarBody } from "app/components/sidebar3/secondary-side-bar/components/DigitalSuiteGenericNavBarBody";
import { DigitalSuiteGenericBarHeader } from "app/components/sidebar3/secondary-side-bar/components/DigitalSuiteGenericNavBarHeader";
import type { ISecondaryBarContents } from "app/components/sidebar3/secondary-side-bar/types/ISecondaryBarContents";
import { BADGE_ITEMS } from "app/components/sidebar3/types";
import {
    buildMonitorAndProtectNavigationSettings,
    type MnPNavBarRouteOverrides,
    navigationSettings,
} from "app/pages/digital-marketing/monitor-and-protect/app/navigation-settings";
import { MonitorAndProtectAccessManager } from "app/pages/digital-marketing/monitor-and-protect/services/access-management";

import { ROUTES } from "./keywords/constants";

export type MnPNavBarOverrides = {
    headerHomeState?: string;
    routeOverrides?: MnPNavBarRouteOverrides;
};

export const monitorAndProtectNavigation = (overrides?: MnPNavBarOverrides): ISecondaryBarContents => {
    return {
        SecondaryBarHeader: (
            <DigitalSuiteGenericBarHeader
                title="primary.sidebar.monitor.protect.title"
                state={overrides?.headerHomeState ?? ROUTES.HOME.stateName}
                navBadgeType={MonitorAndProtectAccessManager.getInstance().isBeta ? BADGE_ITEMS.BETA : BADGE_ITEMS.NONE}
                badgeText="BETA"
            />
        ),
        SecondaryBarBody: (
            <DigitalSuiteGenericNavBarBody
                navObj={
                    overrides?.routeOverrides
                        ? buildMonitorAndProtectNavigationSettings(overrides.routeOverrides)
                        : navigationSettings
                }
            />
        ),
    };
};
